const highlightedHeaderTokens = ({ headings }) => ({
  lineHeights: {
    small: undefined,
    full: undefined,
  },
  fontSizes: {
    full: headings[3],
  },
});

export default highlightedHeaderTokens;
